import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';

const JiraTeamButtonRelayProvider = {
	get(): boolean {
		return (
			// eslint-disable-next-line jira/ff/no-preconditioning
			fg('team-connection-visibility-in-jira') &&
			expVal('team_and_container_m1', 'isEnabled', false)
		);
	},
};

export default JiraTeamButtonRelayProvider;
